// initial state
const state = {
  location: 'north',
  debugPassword: 'password'
}

// getters
const getters = {
  location: state => {
    return state.location
  },

  debugPassword: state => {
    return state.debugPassword
  }
}

// actions
const actions = {
  setLocation ({ commit }, location) {
    commit('setLocation', location)
  }
}

// mutations
const mutations = {
  setLocation (state, location) {
    state.location = location
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
